module.exports = __webpack_public_path__ + "img/googlelocal.3d78c1a3.png";